import { Button, Tooltip } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import React from "react";
import "./BatchBar.scss";

export interface BatchAction {
  key: string;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
  loading?: boolean;
  liClassName?: string;
}

export interface BatchBarProps {
  actions: BatchAction[];
  onCancel?: () => void;
  cancelLabel?: string;
  count?: number;
}

function ActionButton({ action }: { action: BatchAction }) {
  const content = (
    <Button type="link" disabled={action.disabled} onClick={action.onClick}>
      {action.loading ? <LoadingOutlined /> : action.icon}
      {action.label}
    </Button>
  );

  if (action.tooltip && action.disabled) {
    return (
      <Tooltip
        placement="top"
        title={action.tooltip}
        getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
      >
        {content}
      </Tooltip>
    );
  }

  return content;
}

export default function BatchBar({
  actions,
  onCancel,
  cancelLabel = "Cancel",
  count,
}: BatchBarProps) {
  return (
    <section className="batch-bar">
      <ul>
        {actions.map((action) => (
          <li key={action.key} className={action.liClassName}>
            <ActionButton action={action} />
          </li>
        ))}
        {onCancel && (
          <li>
            <Button type="link" onClick={onCancel}>
              <span className="x">×</span>
              {cancelLabel}
            </Button>
          </li>
        )}
      </ul>
      {count != null && count > 0 && (
        <div className="batch-bar-count">{count} selected</div>
      )}
    </section>
  );
}
